import { inject, injectable } from "@launchtray/tsyringe-async";
import { IAnalyticProviderWrapper } from "by/gamefactory/analytics/IAnalyticProviderWrapper";
import { VirtualScreenEvent } from "by/gamefactory/analytics/events/VirtualScreenEvent";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { ShopResourcePackage } from "../resources/ShopResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { IShopModel } from "../model/IShopModel";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";
import { IShopController } from "../controller/IShopController";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { ShopPopupView } from "../view/ShopPopupView";
import { CancellationToken } from "async/CancellationToken";
import { Web3Model } from "../../../../../web3/models/Web3Model";

@injectable()
export class ShopPopupScene extends Viewable<void> {
    public constructor(
        shopResurces: ShopResourcePackage,
        commonResources: CommonResourcesPackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IShopModel") shopModel: IShopModel,
        @inject("IShopController") shopController: IShopController,
        @inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper,
        asyncOperationNotification: AsyncOperationNotification,
        @inject("ILogger") logger: ILogger,
        web3Model: Web3Model,
        cancellationToken: CancellationToken
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new ShopPopupView(
            pcs,
            cancellationToken,
            shopResurces,
            commonResources,
            canvasScaler,
            shopModel,
            shopController,
            logger,
            asyncOperationNotification,
            web3Model,
            analyticsProvider
        );
        analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Player open store page", analyticsProvider.currentEventIndex));
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
